var _path, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrayShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 132,
    viewBox: "0 0 112 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 0C18.928 0 1.21126 20.8187 0.472889 21.7056C0.167906 22.0771 0.000912551 22.5418 0 23.0214L0 64.4938C0 99.5725 32.4634 120.399 46.4178 127.725C46.901 127.948 47.4517 127.978 47.9563 127.808C48.4608 127.639 48.8807 127.283 49.1292 126.815C49.3778 126.346 49.436 125.801 49.292 125.291C49.1479 124.781 48.8125 124.346 48.355 124.075C31.8453 115.408 4.14815 96.1446 4.14815 64.4897V23.8052C7.06015 20.6908 23.3624 4.84271 53.9259 4.14971V129.936C53.9257 130.355 54.0538 130.765 54.2932 131.109C54.5327 131.454 54.872 131.718 55.2662 131.867C55.6603 132.015 56.0905 132.04 56.4995 131.939C56.9085 131.838 57.2768 131.616 57.5556 131.302C64.3461 128.398 112 106.49 112 63.9369V22.6873C112 22.2068 111.831 21.7414 111.523 21.3714C110.909 20.6331 96.1167 3.32472 65.3084 0.235123C64.7625 0.186408 64.2189 0.35204 63.7942 0.696605C63.3694 1.04117 63.097 1.53732 63.0353 2.07898C63.0077 2.34848 63.0338 2.62074 63.1121 2.8802C63.1904 3.13966 63.3193 3.38125 63.4915 3.59116C63.6637 3.80107 63.8758 3.9752 64.1156 4.10359C64.3555 4.23199 64.6185 4.31214 64.8895 4.33946C90.9689 6.95469 105.139 20.6124 107.852 23.4793V63.9369C107.852 100.864 69.0127 121.476 58.0741 126.55V2.06248C58.0741 1.51548 57.8556 0.990877 57.4666 0.604087C57.0776 0.217297 56.5501 0 56 0Z",
    fill: "#929292"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.9523,
    cy: 63,
    rx: 43.9523,
    ry: 44,
    fill: "#929292"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayShield);
export default __webpack_public_path__ + "static/media/gray-shield.457faec3a371c7037849e28dfefbed74.svg";
export { ForwardRef as ReactComponent };